module.exports = __webpack_public_path__ + "static/img/gyl2.05e0ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyl2.png
// module id = dfGB
// module chunks = 1